import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { useFormik, FieldArray, FormikProvider } from 'formik';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { Box, Button } from '@mui/material';

import { viewTech } from '../../../modules/techModule/tech';
import { listProjectTechs } from '../../../modules/techModule/projectTechs';
import SubTitleTemplate from '../../../components/common/template/SubTitleTemplate';
import _ from 'lodash';
import * as techApi from '../../../lib/api/tech';
import * as fileApi from '../../../lib/api/file';
import TechCustForm from '../../../components/techmng/support/TechCustForm';
import TechMultiFileForm from '../../../components/techmng/support/TechMultiFileForm';
import TechReqForm from '../../../components/techmng/support/TechReqForm';
import TechUsersForm from '../../../components/techmng/support/TechUsersForm';
import TechProductListForm from '../../../components/techmng/support/TechProductListForm';
import { setTech } from '../../../modules/chanceModule/tech';

const TechReqFormContainer = ({ project, tech, user, }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [ccUsers, setCcUsers] = useState([]);

  const [initialValues, setInitialValues] = useState({
    custNm: '',
    signStatus: '',
    custAddr: '',
    custEmpNm: '',
    custTel: '',
    custEml: '',
    workTyp: '기술지원',
    workTypDet: '',
    workStDt: '',
    workEdDt: '',
    workTxt: '',
    workEmp: '',
    prdtList: [],
    files: [{ file: null, fileDesc: '' }]
  })


  useEffect(() => {
    if (tech) {
      const cloneTech = _.cloneDeep(tech);
      cloneTech.files = [{ file: null, fileDesc: '' }];
      setCcUsers(tech.refList);
      setInitialValues(cloneTech);

    }

  }, [tech])




  const validationSchema = yup.object({
    custNm: yup.string().required('고객명을 입력하세요'),
    custEmpNm: yup.string().required('담당자명을 입력하세요'),
    custTel: yup.string()
      .matches(
        /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/g,
        "담당자 휴대폰 번호를 확인하십시오"
      ),
    custEml: yup.string().email('담당자 이메일을 확인하세요'),
    workTyp: yup.string().required('기술지원 타입을 선택하세요.'),
    workStDt: yup
      .date()
      .required("작업 요청 시작일을 입력하세요")
      .nullable()
      .default(undefined),
    workEdDt: yup
      .date()
      .required("작업 요청 종료일을 입력하세요")
      .min(yup.ref('workStDt'), '작업 요청 종료일을 확인하세요')
      .when('workStDt', (workStDt, schema) => {
        if (workStDt)
          return schema.required('작업 요청 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
    workTxt: yup.string().required('작업 요청 사항을 입력하세요'),
    prdtList: yup.array().of(
      yup.object().shape({
        productUuid: yup.string().nullable(),
        productCnt: yup.number('수량은 숫자만 가능합니다')
          .min(1, '제품 수량을 확인하세요')
          .when('productUuid', (productUuid, schema) => {
            if (productUuid)
              return schema.required('제품수량을 입력하세요');
          })
      })
    ),
    // files: yup.array().of(
    //   yup.object().shape({
    //     file: yup.mixed().required('파일을 선택하세요'),
    //     fileDesc: yup.string().nullable('비고를 입력하세요'),
    //   })
    // )
  });
  const addCcUsers = (newUser) => {
    let usrs = [...ccUsers, ...newUser];
    let filteredUsrs = _.uniqBy(usrs, 'usrUuid');
    setCcUsers(filteredUsrs);
  }

  const removeCcUser = (user) => {
    const filteredUsers = _.filter(ccUsers, (usr) => usr.usrUuid !== user.usrUuid);
    setCcUsers(filteredUsers);
  }


  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {

      setSubmitting(true);
      onSave(values);
      setSubmitting(false);
    },
  });

  const onFileSave = async (value, techReq) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'tech');
    formData.append('fileAttrVal1', tech.reqUuid);
    formData.append('fileAttrVal2', tech.prjUuid);
    formData.append('fileAttrVal3', '기술 지원 요청');
    formData.append('fileDesc', value.fileDesc);


    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar("첨부파일 업로드 성공", {
          variant: 'success',
        });
      }

    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };


  const onSave = async (values) => {
    let dataToSubmit = {
      reqUuid: tech.reqUuid,
      prjUuid: project.prjUuid,
      custNm: values.custNm,
      signStatus: values.signStatus,
      custAddr: values.custAddr,
      custEmpNm: values.custEmpNm,
      custTel: values.custTel,
      custEml: values.custEml,
      workTyp: values.workTyp,
      workTypDet: values.workTypDet,
      workStDt: (values.workStDt) ? dayjs(values.workStDt).format('YYYY-MM-DD') : null,
      workEdDt: (values.workEdDt) ? dayjs(values.workEdDt).format('YYYY-MM-DD') : null,
      workTxt: values.workTxt,
      workEmp: values.workEmp,
      refList: ccUsers,
      prdtList: values.prdtList,
    };

    try {
      const res = await techApi.editTechReq(dataToSubmit);

      if (res.data.info) {
        if (values.files.length > 0 && values.files[0].file !== null) {
          values.files.forEach(value => {
            onFileSave(value, res.data.info);
          })
        }
        dispatch(viewTech(res.data.info.reqUuid));
        dispatch(listProjectTechs(tech.prjUuid));
      }
      enqueueSnackbar('기술 지원 요청 수정 성공', {
        variant: 'success',
      });
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };


  const onTechConfirm = async () => {
    let dataToSubmit = {
      reqUuid: tech.reqUuid,
      prjUuid: project.prjUuid,
      reqStatus: '지원확인',
      reqGrade: 2,
    }

    try {
      const res = await techApi.editTechReq(dataToSubmit);

      // console.log('res.data.info', res.data.info)
      if (res.data.info) {
        dispatch(viewTech(res.data.info.reqUuid));
        dispatch(listProjectTechs(tech.prjUuid));
      }
      enqueueSnackbar('기술 지원 확인', {
        variant: 'success',
      });
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  }


  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        py: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`
      }}>
        <Box>
          {tech.reqGrade === "1" && (
            <Button
              type="button"
              color="info"
              variant="outlined"
              onClick={onTechConfirm}
            >
              지원확인
            </Button>
          )}
        </Box>
        <Box sx={{ flex: '1 1 auto' }} />
        <Box>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Box>

      <SubTitleTemplate title="고객 정보">
        <TechCustForm formik={formik} />
      </SubTitleTemplate>



      <SubTitleTemplate title="기술 지원 요청 내역">
        <TechReqForm formik={formik} tech={tech} />
      </SubTitleTemplate>

      <SubTitleTemplate title="작업자">
        <TechUsersForm formik={formik} ccUsers={ccUsers} addCcUsers={addCcUsers} removeCcUser={removeCcUser} />
      </SubTitleTemplate>

      <SubTitleTemplate title="공급 제품 정보">
        <FormikProvider value={formik}>
          <TechProductListForm formik={formik} />
        </FormikProvider>
      </SubTitleTemplate>
      <SubTitleTemplate title="첨부 서류">
        <FormikProvider value={formik}>
          <FieldArray name="files"
            render={arrayHelpers => (
              <Box>
                <Box>
                  {formik.values?.files.map((f, index) => {
                    return (
                      <TechMultiFileForm
                        key={index}
                        file={f}
                        index={index}
                        touched={formik.touched}
                        errors={formik.errors}
                        handleChange={formik.handleChange}
                        handleBlur={formik.handleBlur}
                        handleRemove={() => arrayHelpers.remove(index)} />
                    )
                  })}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 2 }}>
                  <Button sx={{ mx: 2 }} color="secondary" variant="outlined" onClick={() => arrayHelpers.push({ fileDesc: '', file: null })}>파일 추가</Button>
                </Box>
              </Box>

            )}

          >

          </FieldArray>
        </FormikProvider>
      </SubTitleTemplate>


      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        py: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`
      }}>
        <Box>
          {tech.reqGrade === "1" && (
            <Button
              type="button"
              color="info"
              variant="outlined"
              onClick={onTechConfirm}
            >
              지원확인
            </Button>
          )}
        </Box>
        <Box sx={{ flex: '1 1 auto' }} />
        <Box>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default TechReqFormContainer;
